export default {
  printFormat: Object.freeze({ APP_A4: 'A4', APP_A5: 'A5' }),
  documentsSettings: {
    acceptanceAct: {
      IN_ACCORDANCE_WITH_TEXT: 'Публичным договором на оказание платных медицинских услуг',
      FAMILIAR_WITH_TEXT: 'Публичным договором, Правилами внутреннего распорядка для пациентов',
    },
  },
}